<template>
  <div>
    <div class="invoice">
      <van-form @submit="saveEvent">
        <van-field name="radio" label="发票类型">
          <template #input>
            <van-radio-group v-model="form.invoiceType" direction="horizontal">
              <van-radio
                class="invoiceType"
                :class="{ TypeActive: form.invoiceType == 0 }"
                :name="0"
              >
                普通发票
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="抬头类型">
          <template #input>
            <van-radio-group v-model="form.buyerType" direction="horizontal">
              <van-radio
                class="invoiceType"
                :class="{ TypeActive: form.buyerType === item.key }"
                v-for="item in buyerTypeArr"
                :key="item.key"
                :name="item.key"
              >
                {{ item.name }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.buyerName"
          name="发票抬头"
          label="发票抬头"
          placeholder="请输入发票抬头"
        />
        <van-field
          v-if="form.buyerType === 1"
          v-model="form.buyerTaxNo"
          name="单位税号"
          label="单位税号"
          placeholder="请输入单位税号"
        />
        <van-field
          v-model="form.buyerAddressPhone"
          name="手机号"
          label="手机号"
          placeholder="请输入手机号"
          type="number"
          required
          :rules="[{ required: true, message: '手机号不能为空' }]"
        />
        <van-field
          v-model="form.buyerIdcard"
          name="身份证号"
          label="身份证号"
          placeholder="请输入身份证号"
          type="text"
          required
          :rules="[{ required: true, message: '身份证号不能为空' }]"
        />
        <van-field
          v-model="form.buyerEmail"
          name="邮箱地址"
          label="邮箱地址"
          placeholder="请输入邮箱地址"
          required
          :rules="[{ required: true, message: '邮箱地址不能为空' }]"
        />
        <div class="saveContent">
          <van-button round size="small" native-type="submit" type="success">
            保存
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
  import { reactive } from 'vue'
  import { useRouter } from 'vue-router'
  import { saveInvoice } from '@/api/invoice/invoice'
  import { Dialog } from 'vant'

  export default {
    setup() {
      // const route = useRoute();
      const router = useRouter()
      // 创建抬头类型
      const buyerTypeArr = [
        {
          name: '个人',
          key: 0,
        },
        {
          name: '单位',
          key: 1,
        },
      ]

      const form = reactive({
        // invoiceType: "普通发票",
        buyerType: 0,
        buyerName: '',
        buyerTaxNo: '',
        buyerAddressPhone: '',
        buyerEmail: '',
        medicalNo: '',
        address: '',
        invoiceType: 0,
        buyerIdcard: '',
      })

      // const wechatCode = route.query.code;
      const adviceCode = localStorage.getItem('changeAdviceCode')

      form.medicalNo = adviceCode
      // requestWechatInfo(wechatCode);

      // 保存
      const saveEvent = () => {
        saveInvoice(form).then(() => {
          Dialog.confirm({
            title: '提示',
            message: '开票申请已提交',
          }).then(() => {
            router.go(-1)
          })
        })
      }
      return {
        form,
        saveEvent,
        buyerTypeArr,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .invoice {
    padding: 10px 10px;
    .saveContent {
      text-align: center;
      margin-top: 50px;
      button {
        width: 50%;
      }
    }
    .invoiceType {
      border: 1px solid #f5f5f5;
      background: var(--basic-btnDisable);
      padding: 2px 10px;
      border-radius: 15px;
    }
    .TypeActive {
      border: 1px solid var(--basic-btnBoder);
      background: var(--basic-btnBackColor);
      :deep(.van-radio__label) {
        color: var(--basic-btnBoder);
      }
    }
    :deep(.van-radio__label) {
      margin: 0;
    }
    :deep(.van-icon) {
      display: none;
    }
  }
</style>
